module.exports = __webpack_public_path__ + "media/home/digitizedImagesAccess-d5470223.png";